import withAPIAction from 'helpers/withAPIAction'
import { MerchantTypeListReq, CreateMerchantTypeReq, DeleteMerchantTypeReq } from './types'
import { getMerchantTypeListAction, createMerchantTypeAction, deleteMerchantTypeAction } from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'

export const merchantTypeListAPI = (data: MerchantTypeListReq, token: string, xmid: any) => {
  const endPoint = APIPath.getMerchantTypeList.replace(':name', data.merchant_type.toString())
  return withAPIAction<MerchantTypeListReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(getMerchantTypeListAction)
}

export const createMerchantTypeAPI = (data: CreateMerchantTypeReq, token: string, xmid: string) => {
  return withAPIAction<CreateMerchantTypeReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.createMerchantType,
    data,
    token,
    xmid,
  })(createMerchantTypeAction)
}

export const deleteMerchantTypeAPI = (data: DeleteMerchantTypeReq, token: string, xmid: string) => {
  const endPoint = APIPath.deleteMerchantType.replace(':id', data.id.toString())
  return withAPIAction<DeleteMerchantTypeReq>({
    method: 'DELETE',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(deleteMerchantTypeAction)
}
